import _ from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const lsTrackingService = {
    _private: {
        events: {
            blur: 'blur',
            focus: 'focus',
            click: 'click',
            attach: 'attach',
            change: 'change',
            'open-external': 'open-external',
            customer_share_variation_component_shown: 'customer_share_variation_component_shown',
            change_my_pro_is_successful: 'change_my_pro_is_successful',
            CompletedReactivation: 'CompletedReactivation',
        },
    },

    identify({ user_id, name, email }) {
        if (!window.analytics || !user_id) {
            return;
        }

        window.analytics.identify({
            userId: user_id,
            traits: {
                name,
                email,
            },
        });
    },

    track({ event, target = '', data = {} }) {
        if (!_.get(lsTrackingService._private.events, event)) {
            console.warn(
                `Tracking event has failed. The event \`${event}\` is missing from the tracking constants.`
            );
            return;
        }

        if (!window.analytics) {
            return;
        }

        window.analytics.track(event, {
            appName: process.env.VUE_APP_NAME,
            target,
            ...data,
        });
    },

    page(data = {}) {
        if (!_.isFunction(_.get(window, 'analytics.page'))) {
            return;
        }
        const path = data.path || location.pathname || ''; // eslint-disable-line no-restricted-globals
        const referrer = data.referrer || '';
        const search = data.search || location.search || ''; // eslint-disable-line no-restricted-globals
        const url = data.url || location.origin + path || ''; // eslint-disable-line no-restricted-globals
        window.analytics.page({
            path,
            referrer,
            search,
            url,
        });
    },
};
